module.exports = __webpack_public_path__ + "img/your-leadership-skills.dbefc774.svg";